import axios from "axios";

import apiRoutes from "@/constants/api-routes";

export interface Collection {
	id: number;
	name: string;
	dataTypeId: number;
	platformId: number;
	platformName: string;
	rulesUsingCount: number;
	createdAt: string;
	updatedAt: string;
}

export interface CollectionEntryDto {
	id: number;
	value: string;
	createdAt: string;
	updatedAt: string;
}

export interface CollectionDetailResponse extends Collection {
	entries: CollectionEntryDto[];
}

export interface CreateCollectionBody {
	name: string;
	platformId: number;
	dataTypeId: number;
}

export interface CreateCollectionEntriesBody {
	entries: { value: string }[];
}

export interface UpdateCollectionEntriesBody {
	removedEntryIds: number[];
	addedEntries: { value: string }[];
	updatedEntries: { id: number; value: string }[];
}

export interface CreateCollectionEntriesResponse {
	entries: CollectionEntryDto[];
}

export interface UpdateCollectionEntriesResponse {
	entries: CollectionEntryDto[];
}

type AuthHeaders = Record<string, string>;

export async function fetchCollections(
	headers: AuthHeaders,
	platformId?: number | string,
): Promise<Collection[]> {
	const response = await axios.get<Collection[]>(apiRoutes.getCollections(platformId), { headers });
	return response.data;
}

export async function createCollectionApi(
	body: CreateCollectionBody,
	headers: AuthHeaders,
): Promise<Collection> {
	const response = await axios.post<Collection>(apiRoutes.createCollection, body, { headers });
	return response.data;
}

export async function deleteCollectionsApi(
	collectionIds: number[],
	headers: AuthHeaders,
): Promise<void> {
	await axios.delete(apiRoutes.deleteCollections, {
		headers,
		data: { collectionIds },
	});
}

export async function patchCollectionApi(
	collectionId: number | string,
	name: string,
	headers: AuthHeaders,
): Promise<Collection> {
	const response = await axios.patch<Collection>(apiRoutes.patchCollection(collectionId), { name }, { headers });
	return response.data;
}

export async function fetchCollectionDetail(
	collectionId: number | string,
	headers: AuthHeaders,
): Promise<CollectionDetailResponse> {
	const response = await axios.get<CollectionDetailResponse>(apiRoutes.getCollectionEntries(collectionId), {
		headers,
	});
	return response.data;
}

export async function createCollectionEntriesApi(
	collectionId: number | string,
	body: CreateCollectionEntriesBody,
	headers: AuthHeaders,
): Promise<CreateCollectionEntriesResponse> {
	const response = await axios.post<CreateCollectionEntriesResponse>(
		apiRoutes.createCollectionEntries(collectionId),
		body,
		{ headers },
	);
	return response.data;
}

export async function updateCollectionEntriesApi(
	collectionId: number | string,
	body: UpdateCollectionEntriesBody,
	headers: AuthHeaders,
): Promise<UpdateCollectionEntriesResponse> {
	const response = await axios.put<UpdateCollectionEntriesResponse>(
		apiRoutes.updateCollectionEntries(collectionId),
		body,
		{ headers },
	);
	return response.data;
}
